import { BillingMode, InvoiceStatus, InvoiceType } from '../../../../../../services/exports/Constants';

export default {
  title: 'Faktury',
  form: {
    title: 'Żądaj nowej płatności',
    company: {
      label: 'Restauracja',
    },
    billing_mode: {
      label: 'Źródło rozliczenia',
    },
    billing_anchor: {
      label: 'Rozpocznij rozliczanie od',
    },
    items: {
      label: 'Pozycje',
    },
    name: {
      label: 'Nazwa',
      placeholder: '1000x Ulotki',
    },
    net_amount: {
      label: 'Kwota (netto)',
      tax_breakdown: '+{{tax}} VAT = {{total}}',
    },
  },
  fields: {
    id: 'ID',
    company: 'Restauracja',
    name: 'Nazwa/Numer',
    billing_mode: 'Źródło rozliczenia',
    type: 'Typ',
    status: 'Status',
    amount: 'Kwota (brutto)',
    created_at: 'Utworzono',
    billing_anchor: 'Rozliczenie od',
    invoice: 'Faktura',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Metoda płatności',
    [BillingMode.InternalInvoicing]: 'Sprzedaż',
  },
  types: {
    [InvoiceType.Manual]: 'Ręczne',
    [InvoiceType.SetupFee]: 'Opłata konfiguracyjna',
    [InvoiceType.Subscription]: 'Subskrypcja',
    [InvoiceType.SubscriptionBridge]: 'Subskrypcja (proporcjonalnie do 5. dnia)',
    [InvoiceType.SubscriptionProration]: 'Subskrypcja (proporcjonalny upgrade)',
  },
  statuses: {
    [InvoiceStatus.Pending]: 'Oczekujące',
    [InvoiceStatus.Processing]: 'Przetwarzanie',
    [InvoiceStatus.Paid]: 'Opłacone',
    [InvoiceStatus.PartiallyRefunded]: 'Częściowo zwrócone',
    [InvoiceStatus.Refunded]: 'Zwrócone',
    [InvoiceStatus.Failed]: 'Nieudane',
  },
  modals: {
    invoice_creation_confirmation: {
      title: 'Czy na pewno chcesz utworzyć fakturę na {{amount}} netto dla {{company}} z {{billingMode}}?',
    },
    invoice_recharge_confirmation: {
      title: 'Czy jesteś pewien?',
      description:
        '<strong>{{company}}</strong> zostanie obciążona <strong>{{amount}} brutto + kara za nieudaną płatność (jeśli dotyczy)</strong> z głównej metody płatności za fakturę {{details}}',
      recharge_failed: {
        title: 'Stripe odrzucił płatność',
        convert_hint:
          'Możesz pobrać tę fakturę ze sprzedaży restauracji. Faktura Stripe zostanie anulowana, a zaległa kwota zostanie potrącona z przyszłych wypłat.',
      },
    },
  },
  buttons: {
    show_transfers: 'Pokaż transfery',
    hide_transfers: 'Ukryj transfery',
    create: 'Utwórz',
    download_pdf: 'Pobierz PDF',
    open_payment_page: 'Otwórz stronę płatności',
    open_invoice_page: 'Otwórz szczegóły faktury',
    add_item: 'Dodaj pozycję',
    convert_to_internal_billing: 'Pobierz ze sprzedaży',
    recharge_invoice: 'Ponownie obciąż fakturę',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    failed_to_create_invoice: 'Nie udało się utworzyć faktury!',
    invoice_got_created: 'Faktura została utworzona!',
    invoice_got_recharged: 'Faktura została ponownie obciążona. Nowa płatność jest przetwarzana!',
    failed_to_recharge_invoice: 'Nie udało się ponownie obciążyć faktury!',
    invoice_got_converted_to_internal_billing:
      'Faktura przekonwertowana na rozliczenie ze sprzedaży. Zaległa kwota zostanie potrącona z przyszłych wypłat.',
    failed_to_convert_invoice_to_internal_billing: 'Nie udało się przekonwertować faktury na rozliczenie ze sprzedaży!',
  },
};
